import { MovieClip } from '@play-co/timestep-core/ui';
import { Container, Texture } from '../../../odie';
import { getMatch2AssetPath } from '../../util/assets';
import { blockPositionView } from '../../util/blockTools';
import { BigEggBlockProps } from './BigEggBlock';
import { CountBlockOptionDef } from '../../defs/block';

const manifest = () => ({
  movieclip: {
    url: getMatch2AssetPath('blocks/bigEgg'),
    loadMethod: MovieClip.animationLoader,
  },
});

export class BigEggBlockView extends Container {
  public movieclip: MovieClip;
  private _count = 0;

  constructor(props: BigEggBlockProps) {
    super();
    blockPositionView(this, props);

    this.movieclip = new MovieClip({
      superview: this.view,
      url: manifest().movieclip.url,
      scale: 0.97,
      defaultAnimation: 'egg_closed',
    });
  }

  public static assets() {
    return Object.values(manifest());
  }

  public get count(): number {
    return this._count;
  }

  public set count(value: number) {
    this._count = value;
    this.updateView();
  }

  private updateView() {
    if (this._count >= 7) {
      this.movieclip.play('egg_closed');
    } else if (this._count > 0) {
      const sceneNum = this.count.toString().padStart(2, '0');
      this.movieclip.play(`egg_open_${sceneNum}`, null, true);
    }
  }
}

export function _createBigEggBlockView(
  props: BigEggBlockProps,
  option: number,
): BigEggBlockView {
  const optionDef = props.options![option] as CountBlockOptionDef;
  const view = new BigEggBlockView(props);
  view.count = optionDef.count;
  return view;
}
